import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["hovered"];
import { getDataAttributes } from '../utils/getDataAttributes';
import { fullWidthCellClassName } from '../utils/fullWidthCellClassName';
import { HIGHLY_SENSITIVE_MASKED_DISPLAY } from '../dataSensitivity/highlySensitiveMaskedDisplay';
import { ShowHighlySensitiveValueButton } from '../dataSensitivity/ShowHighlySensitiveValueButton';
import useComponentMountMetric from '../metrics/useComponentMountMetric';
import { useHovered } from 'foundations-components/transitional/utils/useHovered';
import { View } from 'foundations-components/components/View';
import { Flex } from 'foundations-components/components/Flex';
import { useIsUngatedForDisplayOptimizedFormControl } from '../v2/hooks/useIsUngatedForDisplayOptimizedFormControl';
import { HighlySensitiveDataMaskedDisplay } from '../dataSensitivity/HighlySensitiveDataMaskedDisplay';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const FormattedHighlySensitive = props => {
  const _useHovered = useHovered({}),
    {
      hovered
    } = _useHovered,
    hoveredProps = _objectWithoutPropertiesLoose(_useHovered, _excluded);
  useComponentMountMetric('FormattedHighlySensitive');
  const isUngatedForDisplayOptimizedFormControl = useIsUngatedForDisplayOptimizedFormControl();
  if (isUngatedForDisplayOptimizedFormControl) {
    return /*#__PURE__*/_jsx(HighlySensitiveDataMaskedDisplay, Object.assign({}, props));
  }
  return /*#__PURE__*/_jsxs(Flex, Object.assign({
    display: "inline-flex",
    alignItems: "center",
    position: "relative",
    justifyContent: "center"
  }, hoveredProps, getDataAttributes(props), {
    "data-classname": fullWidthCellClassName,
    children: [/*#__PURE__*/_jsx(View, {
      as: "span",
      position: "absolute",
      children: HIGHLY_SENSITIVE_MASKED_DISPLAY
    }), /*#__PURE__*/_jsx(ShowHighlySensitiveValueButton, {
      isVisible: hovered
    })]
  }));
};